import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as Arrow } from '../../../assets/svg/DashboardArrowRight.svg';
import { ReactComponent as LinkTo } from '../../../assets/svg/LinkTo.svg';
import { translit1 } from '../../../components/common';
import { useLanguage } from '../../../hooks';
import { News, NotificationUnit } from '../../../services/content_v1';
import { NewsItem } from '../../News/components/NewsItem';
import WelcomeMessage from './WelcomeMessage';


interface WelcomeNewsProps {
    news: News[],
    notify?: NotificationUnit[]
}

function WelcomeNews({ news, notify }: WelcomeNewsProps) {
    // const { user } = useAuth();
    const lang = useLanguage();

    const [mainNews, setMainNews] = useState<News | undefined>(undefined);
    const [otherNews, setOtherNews] = useState<News[]>([]);
    const [minNews, setMinNews] = useState<News[]>([]);

    useEffect(() => {
        if (news.length > 0) {
            setMainNews(news.at(0));
            setOtherNews(news.slice(1, 3));
            setMinNews(news.slice(3, 11));
        }
    }, [news]);

    const [showMessage, setShowMessage] = useState(true);
    const closeMessage = () => {
        setShowMessage(false);
    };

    return (
        <section className="welcome-news">
            <header className="welcome-header">
                <h2 className="welcome-header__heading">
                    <a href={`/${lang}/public-news`}>
                        <Trans>cms:NEWS</Trans>
                        <LinkTo />
                    </a>
                </h2>
                <div className="welcome-header__link">
                    <a href={`/${lang}/public-news`}>
                        <Trans>See all</Trans>
                        <LinkTo />
                    </a>
                </div>
            </header>

            {showMessage && (
                notify?.map((n) =>
                    <WelcomeMessage
                        key={n.id}
                        severity={n.severity}
                        icon={n.icon}
                        message={<>
                            <span><strong>{n.title}</strong> {n.summary}</span>
                            {n.metadata.link_url ? (
                                <>
                                    <span className="welcome-message__copy-sep"> · </span>
                                    {n.metadata.link_intro}
                                    &nbsp;
                                    <a href={n.metadata.link_url} target="_blank">
                                        {n.metadata.link_text}
                                        <Arrow />
                                    </a>
                                </>
                            ) : (
                                <>
                                    <span className="welcome-message__copy-sep"> · </span>
                                    <Link to={`/${lang}/public-notify`}>
                                        <Trans>Details</Trans>
                                        <Arrow />
                                    </Link>
                                </>
                            )}
                        </>}
                        onClose={closeMessage}
                    />
                )
            )}

            {news.length > 0 ? (
                <div className="welcome-news__grid">
                    <div className="welcome-news__grid-col">
                        {mainNews && <NewsItem showTopic news={mainNews} big />}
                    </div>
                    <div className="welcome-news__grid-col _wrap">
                        {otherNews.map((n) => <NewsItem key={n.id} showTopic news={n} horizontal w100 />)}
                        <div className="welcome-news__min">
                            {minNews.map((n) => <article key={n.id} className="welcome-news__min-item">
                                <h3 className="welcome-news__min-item-heading">
                                    <a href={`/${lang}/public-news/${n.id}_${translit1(n.title) || ''}`}>{n.title}</a>
                                </h3>
                            </article>)}
                        </div>
                    </div>
                </div>
            ) : (
                <header className="welcome-header">
                    <h3 className="welcome-header__heading">
                        <a href={`/${lang}/public-news`} style={{ fontSize: '20px' }}>
                            <Trans>No news</Trans>
                        </a>
                    </h3>
                </header>
            )}
        </section>
    );
}

export default WelcomeNews;